<script setup lang="ts">
defineProps<{ products: ProductCard<Packet | SingleProduct>[] }>()
</script>

<template>
  <ul class="grid gap-x-7.5">
    <li v-for="product in products" :key="product.id">
      <CardsProduct :product="product" />
    </li>
  </ul>
</template>

<style scoped>
@reference "~/assets/styles/main.css";

ul {
  grid-template-columns: repeat(auto-fit, minmax(min(theme('spacing.64'), 100%), 1fr));
}
</style>
